module.exports = __webpack_public_path__ + "img/curse.5281765a.png";